import React from 'react';
import Banner from './Banner';
import AboutSection from './AboutSection';
import TerminalSection from './TerminalSection';
import FAQSection from './FAQSection';
import Brand from './Brand';
import CTAOne from './CTAOne';

const HomeThreeMain = () => {
	return (
		<>
			<Banner />
			<AboutSection />
			<TerminalSection />
			<FAQSection />
			<Brand />
			<CTAOne />
		</>
	);
}

export default HomeThreeMain;
